import logger from "../../../utils/logger";
import { loadStories, setStories, setStory } from "../reducer/stories";
import * as uiActions from "../reducer/ui";

const storyImageURL = (name) =>
  "https://res.cloudinary.com/dio1saxjw/image/upload/" +
  "w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_white,b_rgb:17a2b8" +
  "/recovery_stories_pics/" +
  name;

const loadStoriesFlow =
  ({ getStoryList }) =>
  ({ dispatch, getState }) =>
  (next) =>
  async (action) => {
    next(action);
    if (action.type === loadStories.type) {
      dispatch(uiActions.setLoading(true));
      try {
        let list = getState().stories.storyList;
        if (list.length === 0) {
          const response = await getStoryList();
          logger()(response.data);
          list = operate(transform(response.data.feed.entry));
          dispatch(setStories(list));
        }
        if (action.payload && parseInt(action.payload) < list.length)
          dispatch(setStory(action.payload));
      } catch (error) {
        dispatch(uiActions.setError(error.message));
      }
      dispatch(uiActions.setLoading(false));
    }
  };

const transform = (list) =>
  list.map((item, _id) => ({
    _id: _id.toString(),
    name: item["gsx$name"] ? item["gsx$name"]["$t"] : "",
    age: item["gsx$age"] ? item["gsx$age"]["$t"] : "",
    created: item["gsx$created"] ? item["gsx$created"]["$t"] : "",
    gender: item["gsx$gender"] ? item["gsx$gender"]["$t"] : "",
    location: item["gsx$location"] ? item["gsx$location"]["$t"] : "",
    image: item["gsx$image"] ? item["gsx$image"]["$t"] : "",
    story: item["gsx$story"] ? item["gsx$story"]["$t"] : "",
  }));

const operate = (list) =>
  list.map((story, _id) => {
    const ar = story.image.split("/");
    const name = ar[ar.length - 1];
    return {
      ...story,
      image: storyImageURL(name),
      desc: `${story.name}, ${story.age} ${story.gender}, from ${story.location}`,
    };
  });

const storiesFlow = [loadStoriesFlow];

export default storiesFlow;
